import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import BotonCancelarSAT from './BotonCancelarSAT';
import ConsultarEstatus from '../../common/ConsultarEstatus';

const BotonesAccionComplemento = ({ isActive, handleOpenModal, datosSellos, emisor, receptor, total, refreshFactura }) => {
    return (
        <Row className="mt-4">
            <Col className="d-flex justify-content-end gap-2">
                <ConsultarEstatus
                    uuid={datosSellos?.UUID}
                    rfcEmisor={emisor?.Rfc}
                    rfcReceptor={receptor?.Rfc}
                    total={total}
                />
                <BotonCancelarSAT 
                    isActive={isActive} 
                    datosSellos={datosSellos}
                    emisor={emisor}
                    refreshFactura={refreshFactura}
                />
                <Button
                    variant="warning"
                    onClick={() => handleOpenModal('cancelar')}
                    className="px-4"
                    disabled={!isActive}
                >
                    <i className="fas fa-ban me-2"></i>
                    {isActive ? 'Cancelar Complemento' : 'Ya Cancelado'}
                </Button>
                <Button
                    variant="danger"
                    onClick={() => handleOpenModal('eliminar')}
                    className="px-4"
                >
                    <i className="fas fa-trash me-2"></i>
                    Eliminar Complemento
                </Button>
            </Col>
            <hr></hr>
        </Row>
    );
};

BotonesAccionComplemento.propTypes = {
    isActive: PropTypes.bool,
    handleOpenModal: PropTypes.func,
    datosSellos: PropTypes.object.isRequired,
    emisor: PropTypes.object.isRequired,
    receptor: PropTypes.object,
    total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    refreshFactura: PropTypes.func
};

export default BotonesAccionComplemento;
